export default {
  "projets": {
    "heroTitle": "Nuestros Proyectos Realizados",
    "heroSubtitle": "Descubra nuestras realizaciones en África: más de 1,000 proyectos en 6 países",
    "stats": {
      "projects": "Proyectos Realizados",
      "countries": "Países",
      "capacity": "Capacidad Instalada"
    },
    "filters": {
      "categoryLabel": "Categoría",
      "regionLabel": "Región",
      "resultsCount": "{{count}} proyecto{{plural}} encontrado{{plural}}",
      "categories": {
        "tous": "Todos los proyectos",
        "micro-reseaux": "Microrredes",
        "industriel": "Industrial",
        "residentiel": "Residencial",
        "telecoms": "Telecomunicaciones",
        "btp": "Ingeniería Civil & Construcción",
        "medical": "Médico"
      },
      "regions": {
        "toutes": "Todas las regiones",
        "afrique": "África",
        "asie": "Asia",
        "ameriques": "Américas",
        "europe": "Europa"
      }
    },
    "photoGallery": {
      "badge": "Galería",
      "title": "Fotos de Nuestras Obras",
      "subtitle": "Imágenes reales de nuestras instalaciones e intervenciones en terreno. Haga clic para ampliar.",
      "categories": {
        "tous": "Todas las obras",
        "genie-civil": "Ingeniería Civil",
        "btp": "BTP & Construcción",
        "installation-electrique": "Instalación Eléctrica",
        "montage-solaire": "Montaje Solar"
      },
      "emptyState": "No hay fotos en esta categoría"
    },
    "projectCard": {
      "capacity": "Capacidad:",
      "beneficiaries": "Beneficiarios:",
      "duration": "Duración:",
      "partners": "Socios:"
    },
    "emptyState": {
      "title": "Ningún proyecto encontrado",
      "description": "Intente modificar sus filtros para ver más resultados."
    },
    "cta": {
      "title": "¿Su proyecto es el próximo?",
      "subtitle": "Únase a nuestros clientes satisfechos y benefíciese de nuestra experiencia para su proyecto de energía renovable.",
      "quoteBtn": "Solicitar Presupuesto",
      "contactBtn": "Contáctenos"
    },
    "list": [
      {
        "titre": "Microrred Rural Zambia",
        "description": "Instalación completa de microrred para electrificación de 12 aldeas rurales con sistema de gestión inteligente y almacenamiento con baterías de litio.",
        "details": { "beneficiaires": "15,000 habitantes", "duree": "18 meses", "partenaires": "Banco Mundial, Gobierno de Zambia" }
      },
      {
        "titre": "Complejo Industrial Malí",
        "description": "Sistema híbrido solar-red para zona industrial con optimización energética y reducción del 60% de costes eléctricos.",
        "details": { "beneficiaires": "50 empresas", "duree": "24 meses", "partenaires": "Gobierno de Malí, Banco Africano de Desarrollo" }
      },
      {
        "titre": "Campus Universitario Senegal",
        "description": "Instalación solar con almacenamiento para campus universitario, incluyendo estaciones de carga para vehículos eléctricos.",
        "details": { "beneficiaires": "25,000 estudiantes", "duree": "12 meses", "partenaires": "Universidad Cheikh Anta Diop, Ministerio de Energía de Senegal" }
      },
      {
        "titre": "Hospital Rural Tanzania",
        "description": "Sistema solar de emergencia para centro médico con alimentación continua y respaldo automático.",
        "details": { "beneficiaires": "50,000 pacientes/año", "duree": "8 meses", "partenaires": "OMS, Ministerio de Salud de Tanzania" }
      },
      {
        "titre": "Red de Telecom Benín",
        "description": "Alimentación solar para 50 sitios de telecomunicaciones con monitoreo centralizado.",
        "details": { "beneficiaires": "2 millones de abonados", "duree": "15 meses", "partenaires": "Operadores de telecom, ARCEP Benín" }
      },
      {
        "titre": "Mini-Red Togo",
        "description": "Microrred comunitaria para 8 aldeas con sistema de pago móvil.",
        "details": { "beneficiaires": "12,000 habitantes", "duree": "20 meses", "partenaires": "Banco Africano de Desarrollo, FAO" }
      },
      {
        "titre": "Granja Solar Benín",
        "description": "Gran granja solar conectada a la red nacional con tecnología de seguimiento solar.",
        "details": { "beneficiaires": "100,000 hogares", "duree": "30 meses", "partenaires": "ARCEP Benín, Banco Europeo de Inversiones" }
      },
      {
        "titre": "Centro Comercial Senegal",
        "description": "Instalación solar en tejado con autoconsumo y venta de excedentes.",
        "details": { "beneficiaires": "50,000 visitantes/día", "duree": "6 meses", "partenaires": "Dakar Trade Center, APIX Senegal" }
      },
      {
        "titre": "Mina de Oro Malí",
        "description": "Sistema híbrido solar-diésel para explotación minera con reducción del 40% del consumo de combustible.",
        "details": { "beneficiaires": "2,000 empleados", "duree": "18 meses", "partenaires": "Compañía minera, IFC" }
      },
      {
        "titre": "Hospital Regional Senegal",
        "description": "Sistema solar de respaldo para hospital regional con inversores médicos certificados.",
        "details": { "beneficiaires": "200,000 pacientes/año", "duree": "10 meses", "partenaires": "Ministerio de Salud de Senegal, Cooperación Francesa" }
      },
      {
        "titre": "Universidad Tecnológica Togo",
        "description": "Campus solar inteligente con sistema de gestión energética y laboratorios de investigación.",
        "details": { "beneficiaires": "30,000 estudiantes", "duree": "14 meses", "partenaires": "Universidad de Lomé, UNESCO" }
      },
      {
        "titre": "Red de Telecom Benín — Extensión",
        "description": "Alimentación solar para infraestructura 4G/5G con baterías de respaldo de alta capacidad.",
        "details": { "beneficiaires": "5 millones de abonados", "duree": "12 meses", "partenaires": "MTN Benín, ARTCI" }
      },
      {
        "titre": "Cimentaciones Torres MTN — Benín",
        "description": "Construcción de 120 cimentaciones de hormigón armado para torres de telecomunicaciones autosoportadas y arriostradas. Movimiento de tierras, armado, encofrado y hormigonado en 15 sitios en todo el país.",
        "details": { "beneficiaires": "3 millones de abonados", "duree": "10 meses", "partenaires": "MTN Benín, Huawei" }
      },
      {
        "titre": "Estructura Metálica Industrial — Senegal",
        "description": "Fabricación y montaje de 850 toneladas de estructuras metálicas para un almacén logístico de 12.000 m². Vigas de celosía, correas, arriostramientos y revestimiento de doble piel.",
        "details": { "beneficiaires": "500 empleos creados", "duree": "14 meses", "partenaires": "Grupo industrial senegalés, Ericsson" }
      },
      {
        "titre": "Cimentaciones Telecom — Malí",
        "description": "Construcción de 200 cimentaciones para torres de telecomunicaciones en zonas rurales. Estudios geotécnicos, cimentaciones superficiales y profundas, mallas de puesta a tierra.",
        "details": { "beneficiaires": "1.5 millones de abonados", "duree": "8 meses", "partenaires": "Orange Malí, Nokia" }
      },
      {
        "titre": "Centro de Datos — Senegal",
        "description": "Construcción llave en mano de un centro de datos de 3.200 m² incluyendo obra gruesa, estructura metálica, impermeabilización, lotes técnicos y sistema de refrigeración redundante.",
        "details": { "beneficiaires": "Operadores regionales", "duree": "18 meses", "partenaires": "Sonatel, Huawei Technologies" }
      }
    ]
  }
};